/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const useEmailId = () => {
  const urlParams = new URLSearchParams(window.location.search);
  let email = urlParams.get("emailId");
  if (email) {
    email = String(email).trim();
  }
  return {
    email,
  };
};
